import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowHeadlineConverter extends CmsConverterService<PanelRowHeadlineData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_panel_row_headline ?? defaultTextInput,
      spacing: {
        top: formData.st_panel_row_headline_spacing_top?.value?.identifier ?? '',
        bottom: formData.st_panel_row_headline_spacing_bottom?.value?.identifier ?? ''
      },
    }
  }
}

export const PANEL_ROW_HEADLINE_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowHeadlineData>>('PanelRowHeadlineConverter')

export interface PanelRowHeadlineData extends ConvertedComponentData {
  headline: TextInput;
  spacing: Spacing;
}
